import { toast } from "@/hooks/use-toast";
import { Candidate } from "@/types/candidate";
import { supabase } from "@/integrations/supabase/client";
import { getMergeConfig } from "@/config/mergeConfigRegistry";
import { generateSelectFieldsFromConfig } from "@/utils/mergeConfigUtils";

export const fetchCandidatesFromDB = async (): Promise<Candidate[]> => {
    try {
          try {
            const { data, error } = await supabase
                .from('candidates')
                .select('id, name, email, phone, function, skills, match_score, status, location, default_resume, manager');

            if (error) {
                throw error;
            }

            if (data) {
                // Transform data to match the Candidate interface
                const transformedData: Candidate[] = data;

                return transformedData;
            }

            return [];
        } catch (error) {
            console.error("Error fetching candidates:", error);
            toast({
                title: "Failed to load candidates",
                description: "Using sample data instead.",
                variant: "destructive",
            });

            // Return mock data as fallback
            return [];
        }

    } catch (error) {
        console.error("Error fetching candidates:", error);
        toast({
            title: "Failed to load candidates",
            description: "Using sample data instead.",
            variant: "destructive",
        });

        // Return mock data as fallback
        return []
    }
};

// Function to fetch specific candidates from database by IDs
// Uses direct Supabase call to avoid circular dependency
export const fetchCandidatesByIds = async (candidateIds: string[]): Promise<Candidate[]> => {
    try {
        //console.log("🔄 Fetching candidates by IDs:", candidateIds);

        // Get the appropriate select fields from the merge configuration
        // Note: We also include documents() for candidate-document relationships
        const mergeConfig = getMergeConfig("candidates");
        const baseSelectFields = mergeConfig ? generateSelectFieldsFromConfig(mergeConfig) : "*";
        const selectFields = `${baseSelectFields}, documents()`;
        
        //console.log(`🔍 Fetching candidates with fields: ${selectFields}`);

        const { data, error } = await supabase
            .from('candidates')
            .select(selectFields)
            .in('id', candidateIds);

        if (error) {
            throw error;
        }

        // Transform data to match the Candidate interface
        const transformedData: Candidate[] = (data || []) as unknown as Candidate[];

        //console.log("✅ Fetched candidates:", transformedData.length, "items");
        return transformedData;
    } catch (error) {
        console.error("Error fetching candidates by IDs:", error);
        toast({
            title: "Failed to load fresh candidate data",
            description: "Using cached data instead.",
            variant: "destructive",
        });
        return [];
    }
};
